import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import ProfileImg from '../assets/logo1.png';
import '../css/general/Sidebar.css';
import 'animate.css';

const Sidebar = ({ userData, notifTypes, clearNotif }) => {
    const [collapsed, setCollapsed] = useState(true);
    const navigate = useNavigate();
    const isAdmin = localStorage.getItem(('isAdmin'));
    const isSubAdmin = localStorage.getItem(('isStaff'));
    const [showLogout, setShowLogout] = useState(false);
    

    const toggleSidebar = () => {
        setCollapsed(!collapsed);
    };

    const handleLogout = () => {
        localStorage.removeItem('userData');
        localStorage.removeItem('isAdmin', 'true');
        localStorage.removeItem('isStaff', 'true');
                navigate('/login');
        window.location.reload();
    }

    const showRedDot = (title) => notifTypes?.[title];
    
    return (
        <>
            <section className={`dashboard-sidebar ${collapsed ? "collapsed animate__animated animate__fadeInRight" : "animate__animated animate__fadeInLeft"}`}>
                <div className='overflow-y-auto'>

                    <div className='text-center my-4'>
                        <img src={ProfileImg} className='sidebar-logo' alt='sidebar profile' />
                        <p className='sidebar-text-link text-muted'>{userData.name}</p>
                    </div>


                    {isAdmin && (
                        <>
                            <p className='sidebar-text' onClick={() =>{ navigate('/dashboard'); setCollapsed(true)}}>
                                <i class="fa-solid me-2 fa-house-circle-check"></i><Link className='sidebar-text-link' to='/dashboard'>Dashboard</Link></p>

                            <p className='sidebar-text' onClick={() =>{ navigate('/overview'); setCollapsed(true)}}>
                                <i class="fa-solid me-2 fa-database"></i><Link className='sidebar-text-link' to='/overview'>Overview</Link></p>


                                <p className='sidebar-text' onClick={() =>{ navigate('/profile'); setCollapsed(true); clearNotif("New Signup")}}>
                                <i class="fa-solid me-2 fa-circle-user"></i><Link className='sidebar-text-link' to='/profile'>Profile</Link>
                                 {showRedDot("New Signup") && <span className="red-dot" />}</p>

                            <p className='sidebar-text' onClick={() =>{ navigate('/manage-orders'); setCollapsed(true); clearNotif("New Order Placed")}}>
                                <i class="fa-solid me-2 fa-list"></i><Link className='sidebar-text-link' to='/manage-orders'>Manage Orders</Link>
                                {showRedDot("New Order Placed") && <span className="red-dot" />}</p>

                            <p className='sidebar-text' onClick={() =>{ navigate('/manage-prescription'); setCollapsed(true); clearNotif("Prescription")}}>
                                <i class="fa-regular me-2 fa-clipboard"></i><Link className='sidebar-text-link' to='/manage-prescription'>Manage Prescription</Link>
                                 {showRedDot("Prescription") && <span className="red-dot" />}</p>

                            <p className='sidebar-text' onClick={() =>{ navigate('/add-product'); setCollapsed(true)}}>
                                <i class="fa-solid me-2 fa-square-plus"></i><Link className='sidebar-text-link' to='/add-product'>Add Product</Link></p>

                            <p className='sidebar-text' onClick={() =>{ navigate('/manage-coupons'); setCollapsed(true)}}>
                                <i class="fa-solid me-2 fa-tag"></i><Link className='sidebar-text-link' to='/manage-coupons'>Coupons</Link></p>

                            <p className='sidebar-text' onClick={() =>{ navigate('/add-branch'); setCollapsed(true)}}>
                                <i class="fa-solid me-2 fa-user-plus"></i><Link className='sidebar-text-link' to='/add-branch'>Add Branch</Link></p>

                                <p className='sidebar-text' onClick={() =>{ navigate('/add-delivery-agent'); setCollapsed(true)}}>
                                <i class="fa-solid me-2 fa-truck-fast"></i><Link className='sidebar-text-link' to='/add-delivery-agent'>Delivery Agent</Link></p>

                                <p className='sidebar-text' onClick={() =>{ navigate('/delivery-history'); setCollapsed(true)}}>
                                <i class="fa-solid me-2 fa-clock-rotate-left"></i><Link className='sidebar-text-link' to='/delivery-history'>Delivery History</Link></p>


                            <p className='sidebar-text' onClick={() => setShowLogout(true)}>
                                <i class="fa-solid me-2 fa-right-from-bracket"></i><span className='sidebar-text-link'>Logout</span></p>
                        </>
                    )}

                    {isSubAdmin && (
                        <>
                            <p className='sidebar-text' onClick={() =>{ navigate('/branch-dashboard'); setCollapsed(true)}}>
                                <i class="fa-solid me-2 fa-house-circle-check"></i><Link className='sidebar-text-link' to='/branch-dashboard'>Dashboard</Link></p>

                            <p className='sidebar-text' onClick={() =>{ navigate('/profile'); setCollapsed(true)}}>
                                <i class="fa-solid me-2 fa-circle-user"></i><Link className='sidebar-text-link' to='/profile'>Profile</Link></p>

                                    {/* <p className='sidebar-text' onClick={() =>{ navigate('/my-medicine'); setCollapsed(true)}}>
                                    <i class="fa-solid me-2 fa-store"></i><Link className='sidebar-text-link' to='/my-medicine'>My Medicine</Link></p> */}

                                <p className='sidebar-text' onClick={() =>{ navigate('/my-orders'); setCollapsed(true)}}>
                                <i class="fa-solid me-2 fa-list"></i><Link className='sidebar-text-link' to='/my-orders'>Order History</Link></p>

                            <p className='sidebar-text' onClick={() => setShowLogout(true)}>
                                <i class="fa-solid me-2 fa-right-from-bracket"></i><span className='sidebar-text-link'>Logout</span></p>
                        </>
                    )}

                    <button className="w-auto sidebar-btn float-end" onClick={toggleSidebar}>
                        <i className={`fa-solid ${collapsed ? "fa-angle-left" : "fa-angle-right"}`}></i>
                    </button>
                </div>
            </section>

            {showLogout && (
    <>
              <section className='delete-dialog px-3' onClick={() => setShowLogout(false)}>
            <div className='bg-white col-lg-4 col-md-8 mx-auto px-3 py-3 rounded-4' onClick={(e) => e.stopPropagation()}>
              <p className='featured-category my-4'>Do you Really want to Log Out?</p>
              <button className='success-btn' onClick={() => handleLogout()}>Yes</button>&nbsp;&nbsp;
              <button className='danger-btn' onClick={() => setShowLogout(false)}>No</button>
            </div>
          </section>

    </>
)}


        </>
    )
}

export default Sidebar
